import styled from 'styled-components';
import breakpoints from 'theme/atoms/breakpoints';
import * as Modal from 'theme/components/Modal.style';
import * as Text from 'theme/components/Text.style';
import * as Buttons from 'theme/components/Buttons.style';

export const Card = styled(Modal.Card)`
  align-items: center;
  border-radius: 40px;
  box-shadow: none;
  box-sizing: border-box;
  gap: 30px;
  justify-content: center;
  max-width: 600px;
  min-height: 320px;
  padding: 60px 30px 30px 30px;
  width: 420px;

  > * {
    flex-grow: 0;
    flex-shrink: 0;
  }

  @media (max-width: ${breakpoints.mobileL}) {
    border-radius: 30px;
    max-width: 90vw;
    width: 90vw;
  }
`;

export const TextContent = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 15px;
  text-align: center;
  width: 100%;
`;

export const Title = styled(Text.H3)`
  text-align: center;
  width: 100%;
`;

export const Message = styled(Text.P2)`
  text-align: center;
  width: 100%;
`;

export const CloseButton = styled(Buttons.SecondaryLightIcon)`
  position: absolute;
  right: 25px;
  top: 25px;
`;
